import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
import { Table, Jumbotron, Button, Form } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
import Menu from '../menu';
import config from '../../config';
//import funciones from '../../middleware/funciones';
//import { Header } from 'react-bootstrap/lib/Modal';

class CodigoBarra extends Component {
    constructor(props) {
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        super(props);
        this.state = {
            data: [],
            empresa: currentCompany,
            tipo: currentUserType,
            busqueda: ""
        };
    }
    componentDidMount() {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/barcode/', datasend)
            .then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const info = data.data;
                    this.setState({ data: info })
                }
            });
    }

    render() {
        const dato = (this.state.data) ? this.state.data : [];
        const { busqueda } = this.state;

        return (

            <div className="contenedor">
                <Menu></Menu>
                <Jumbotron className="Jumbotron">
                    <h1>Modulo Codigo de Barra</h1>
                </Jumbotron>
                <Button className="plus m-2" size="sm" href="/codigobarra/crear/" variant="outline-primary">Crear Codigo Barras</Button>
                <Form.Control className="mb-2 mr-sm-2" id="busquedaItem" placeholder="Codigo o Nombre" onChange={(e) => this.setState({ busqueda: e.target.value })} value={busqueda} />
                <Table hover bordered responsive size="sm" className="table">
                    <thead>
                        <tr>
                            <th>EMPRESA</th>
                            <th>CODIGO BARRA</th>
                            <th>CODIGO ITEM</th>
                            <th>REFERENCIA</th>
                            <th>DESCRIPCION</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dato.map(function (currentData, index) {
                            if (currentData.REFERENCIA_ITEM.toLowerCase().search(busqueda.toLowerCase()) > -1
                                || currentData.DESCRIPCION_ITEM.toLowerCase().search(busqueda.toLowerCase()) > -1
                                || currentData.CODIGO_BARRA.toLowerCase().search(busqueda.toLowerCase()) > -1) {
                                return <tr key={index + "d0"}>
                                    <td>{currentData.ID_EMPRESA}</td>
                                    <td>{currentData.CODIGO_BARRA}</td>
                                    <td>{currentData.CODIGO_ITEM}</td>
                                    <td>{currentData.REFERENCIA_ITEM}</td>
                                    <td align="left">{currentData.DESCRIPCION_ITEM}</td>
                                    <td><Button size="sm" href={"/codigobarra/crear/?" + currentData.ID_CODIGOS_BARRA} variant="outline-primary">Editar</Button></td>
                                </tr>
                            } else {
                                return null;
                            }
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }
}
export default (CodigoBarra);